import {Dispatch} from 'redux';
import {setAuthenticationAction} from '../store/ui/actions';

export class WS {
    private ws: WebSocket = null;
    private retryCount = 0;

    public dispatch: Dispatch;
    public onConnectionChanged: (connected: boolean, retryCount: number) => void;
    public onmessage: (ev: MessageEvent) => void;
    public onopen: () => void;

    public constructor(private url: string) {
        this.connect();
    }

    public send(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
        this.ws.send(data);
    }

    private connect = () => {
        this.ws = new WebSocket(this.url);
        this.ws.onclose = () => {
            this.retryCount++;
            if (this.onConnectionChanged) {
                this.onConnectionChanged(false, this.retryCount);
            }
            this.dispatch(setAuthenticationAction(null));
            setTimeout(() => this.connect(), 1000);
        };

        this.ws.onopen = () => {
            this.retryCount = 0;
            if (this.onConnectionChanged) {
                this.onConnectionChanged(true, this.retryCount);
            }
            if (this.onopen) {
                this.onopen();
            }
        };

        this.ws.onerror = () => {
            this.ws.close();
        };

        this.ws.onmessage = (ev: MessageEvent) => {
            if (this.onmessage) {
                this.onmessage(ev);
            }
        };
    };
}
